<template>
    <li class="nav-item dropdown no-chevron" v-if="player">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <template v-if="currentProfile != null">
                <div :class="['badge-half', currentProfile.boardtype == 1 ? 'steel': 'edart']">
                    <i class="icn-steelboard" v-if="currentProfile.boardtype == 1"></i>
                    <i class="icn-eboard" v-if="currentProfile.boardtype == 2"></i>
                    <span>{{currentProfile.name}}</span>
                </div>
            </template>
            <template v-if="currentProfile == null">
                <i class="icn-steelboard"></i>
                {{__("profile.profile_selection")}}
            </template>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
        <span class="dropdown-item" href="#">{{__("profile.profile_selection")}}</span>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#" v-for="profile in loadedProfiles" :key="profile.id" @click="selectprofile(profile.id)">
            <i class="icn-steelboard" v-if="profile.boardtype == 1"></i>
            <i class="icn-eboard" v-if="profile.boardtype == 2"></i>
            {{profile.name}}
        </a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="/profiles"><i class="fas fa-sign-in-alt"></i> {{__("profile.profiles_edit")}}</a>
        </div>
    </li>
</template>

<script>
    export default {
        props: {
            profiles: null,
            player: null
        },
        data() {
            return {
                loadedProfiles: [],
                currentProfile: null,
                observers: []
            }
        },
        created() {
            this.$root.$on('ProfileSelectorAddObserver', (callback) => {
                this.observers.push(callback)
                if (window.currentProfile) {
                    callback(window.currentProfile)
                }
            })

            if (this.player) {
                window.player = this.player;
            }
        },
        mounted() {
            this.loadedProfiles = this.profiles;
            this.loadProfile();

            this.$root.$on('updateBoardProfile', (options) => {
                this.updateBoardProfile(options);
            })
        },
        methods: {
            selectprofile(id) {
                localStorage.setItem("currentProfileId", id);
                this.loadProfile(true)
            },
            loadProfile(reload = false) {
                var id = localStorage.getItem("currentProfileId");
                if (id) {
                    this.loadedProfiles.forEach(p => {
                        if (p.id == id) this.currentProfile = p;
                    });
                }
                window.currentProfile = this.currentProfile
                document.cookie = "currentProfile=" + JSON.stringify(this.currentProfile)+ ";expires=Fri, 03 Aug 2099 12:00:00 UTC; path=/";
                if (reload)
                    location.reload()
                else
                    this.notifyObservers();
            },
            updateBoardProfile(options) {
                //update js part
                options.forEach(option => {
                    window.currentProfile[option.id] = option.value;
                });
                //update database
                var data = window.currentProfile;
                data._method = "PATCH"
                axios.post("/profiles/" + data.id, data);
                this.notifyObservers();
            },
            notifyObservers() {
                this.observers.forEach(observer => {
                    observer(window.currentProfile)
                });
            }
        }
    }
</script>
